import {styled} from "@mui/material/styles"
import {FormControlLabel, Checkbox} from "@mui/material"
import {breakpoints} from "@next/themes"

interface IFacetCountLabel {
    disabled?: boolean
}

export const FacetCountLabel = styled("span")<IFacetCountLabel>`
    color: ${props => (props?.disabled ? props.theme.colours.text.disabled : props.theme.colours.text.muted)};
    display: inline-block;
    margin-left: 0.125rem;
`

export const FacetTooltipIcon = styled("img")`
    display: none;
    opacity: 1;
    position: absolute;
    right: -0.3125rem;
    padding-top: 0rem;
    width: 2rem;
    height: 2rem;
    z-index: 0;
    outline: none;

    @media (min-width: ${breakpoints.values.lg}px) {
        display: block;
    }
`

interface FacetLabetTextProperties {
    needsTruncating: boolean
}

export const FacetLabelText = styled("span", {
    shouldForwardProp: prop => prop !== "needsTruncating",
})<FacetLabetTextProperties>`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: ${props => (props.needsTruncating ? "10rem" : "auto")};
`
export const HiddenNoTranslationFacetValue = styled("span")`
    display: none;
`
export const FacetCheckbox = styled(Checkbox)`
    padding: 0;
    margin-right: 0.5rem;
`

export const FacetFormControl = styled(FormControlLabel)`
    margin: 0;
    padding: 0.3rem 0;
    min-width: 0;
    & > span:last-child {
        overflow: hidden;
        width: auto;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
`

export const FacetWrapper = styled("div")`
    display: flex;
    align-items: center;
    cursor: pointer;
    line-height: 2rem;
    min-width: 0;
`
